import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useUserInfo } from '../../Authentication/hooks'
import NavigationComponent from '../navigationComponent'
import {
  customPostRequest,
  fetchUserSubscription,
  validateVacationCategoryData,
  createNavigationHandlers,
  handleAsyncError
} from './utils/categoryUtils'
import '../../../assets/stylesheets/kategories.css'

const VacationCategory = () => {
  const [vacationTitle, setVacationTitle] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [location, setLocation] = useState('')
  const [vacations, setVacations] = useState([])
  const { userId } = useUserInfo()
  const [message, setMessage] = useState('')
  const navigate = useNavigate()
  const [categoryCreated, setCategoryCreated] = useState(false)
  const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
  const [showUpgradeLink, setShowUpgradeLink] = useState(false)

  const { handleHomeClick, handleUploadClick, handleSubscribeClick } =
    createNavigationHandlers(navigate)

  const handleCreate = async () => {
    if (!userId) {
      setMessage('User not authenticated')
      setShowUpgradeLink(false)
      return
    }

    if (!vacationTitle || !(fromDate || toDate || location)) {
      setMessage(
        'Please enter vacation title and at least one of date or location'
      )
      setShowUpgradeLink(false)
      return
    }

    try {
      const subscriptionData = await fetchUserSubscription(
        userId,
        API_GATEWAY_URL
      )
      if (!subscriptionData) {
        setMessage('Failed to fetch subscription data')
        setShowUpgradeLink(true)
        return
      }

      const { categoryCount, categoryLimit } = subscriptionData

      console.log('Subscription Data:', categoryCount + 1, categoryLimit)
      if (categoryCount >= categoryLimit) {
        setMessage('You have reached your category limit.')
        setShowUpgradeLink(true)
        return
      }
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'fetching category count')
      setMessage(`Failed to fetch category count: ${errorMessage}`)
      setShowUpgradeLink(true)
      return
    }

    const categoryData = {
      userId: userId,
      name: vacationTitle,
      type: 'leisure',
      subType: 'vacation',
      calendarAttrs: {
        fromDate: fromDate ? fromDate + 'T00:00:00Z' : undefined,
        toDate: toDate ? toDate + 'T23:59:59Z' : undefined,
        location: location
      }
    }

    if (!validateVacationCategoryData(categoryData, setMessage)) {
      return
    }

    try {
      const apiURL = `${process.env.REACT_APP_API_GATEWAY_URL}/k1/users/${userId}/categories`
      const responseData = await customPostRequest(apiURL, categoryData)

      if (responseData.error) {
        throw new Error(responseData.error)
      }

      setVacations(prev => [
        ...prev,
        { vacationTitle, fromDate, toDate, location }
      ])
      setVacationTitle('')
      setFromDate('')
      setToDate('')
      setLocation('')
      setMessage('Category created successfully!')
      setCategoryCreated(true)
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'creating category')
      setMessage(`Failed to create category: ${errorMessage}`)
    }
  }

  return (
    <div className="vacation-category">
      <NavigationComponent handleHomeClick={handleHomeClick} />
      <h2 className="category-header">Vacation</h2>
      <p className="asterix-message">
        * Select a date, a date range, location or both!
      </p>
      {message && <p className="message">{message}</p>}
      {showUpgradeLink && (
        <p>
          Please{' '}
          <span className="link-like" onClick={handleSubscribeClick}>
            upgrade
          </span>{' '}
          your plan.
        </p>
      )}
      {message === 'Category created successfully!' && (
        <p>
          <Link to="/gallery">Click here</Link> to return to the main gallery.
        </p>
      )}
      <input
        type="text"
        placeholder="Vacation Title"
        value={vacationTitle}
        onChange={e => setVacationTitle(e.target.value)}
        className="input-field"
      />
      <input
        type="date"
        value={fromDate}
        onChange={e => setFromDate(e.target.value)}
        className="input-field"
      />
      <input
        type="date"
        value={toDate}
        onChange={e => setToDate(e.target.value)}
        className="input-field"
      />
      <input
        type="text"
        placeholder="Location"
        value={location}
        onChange={e => setLocation(e.target.value)}
        className="input-field"
      />
      <div className="button-group">
        <button onClick={handleCreate} className="create-button">
          Create
        </button>
      </div>
      {categoryCreated && (
        <div className="list_and_upload">
          <ul>
            {vacations.map((vacation, index) => (
              <li
                className="added-list"
                key={`${vacation.vacationTitle}-${vacation.fromDate}-${vacation.toDate}-${index}`}
              >
                {vacation.vacationTitle} -
                {vacation.fromDate && ` ${vacation.fromDate} to `}
                {vacation.toDate && vacation.toDate}
                {vacation.location && ` at ${vacation.location}`}
              </li>
            ))}
          </ul>
          <button className="upload-button-list" onClick={handleUploadClick}>
            Upload Photos
          </button>
        </div>
      )}
    </div>
  )
}

export default VacationCategory
